import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import customModalTextWGCC from "../../../../src/content/will-graham-christmas-card/customModalText";
import customModalHeaderWGCC from "../../../../src/content/will-graham-christmas-card/customModalHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  customModalTextWGCC,
  customModalHeaderWGCC,
  React
};